// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footer_wrapper__JJPR7","left":"footer_left__3l4og","right":"footer_right__2cEW7","number":"footer_number__2FBEw"};